import { isGlobalParent, isGlobalChild, getGlobalId } from './node'
import { resolver } from '../editor'

export const canDrag = (currentNode, helpers, fun) => {
  if (currentNode.data.props.conditions.disabled) {
    return false
  }

  if (fun) {
    return fun(currentNode, helpers)
  } else {
    return true
  }
}

export const canDrop = (targetNode, helpers, fun) => {
  if (targetNode.data.props.conditions.disabled) {
    return false
  }

  if (fun) {
    return fun(targetNode, helpers)
  } else {
    return true
  }
}

export const canMoveIn = (incomingNode, currentNode, helpers, fun) => {
  if (currentNode.data.props.conditions.disabled) {
    return false
  }

  // ListImageBox e ListImageBoxItem vanno sempre insieme
  if (incomingNode.data.name === 'ListImageBoxItem') return currentNode.data.name === 'ListImageBox'

  if (currentNode.data.name === 'ListImageBox') return incomingNode.data.name === 'ListImageBoxItem'

  // ListIconBox e RowIcons vanno sempre insieme con ListIconBoxItem
  if (incomingNode.data.name === 'ListIconBoxItem')
    return currentNode.data.name === 'ListIconBox' || currentNode.data.name === 'RowIcons'

  if (currentNode.data.name === 'ListIconBox') return incomingNode.data.name === 'ListIconBoxItem'

  // ListImageBox e CopertinaBox possono essere inseriti solo nella ROOT (fullscreen)
  if (incomingNode.data.name === 'ListImageBox' || incomingNode.data.name === 'CopertinaBox')
    return currentNode.data.name === 'ROOT'

  if (fun) {
    return fun(incomingNode, currentNode, helpers)
  } else {
    return true
  }
}

export const canMoveOut = (outgoingNode, currentNode, helpers, fun) => {
  if (outgoingNode.data.props.conditions.disabled) {
    return false
  }

  if (outgoingNode.data.name === 'TextEditor') {
    return (
      currentNode.data.name !== 'ListIconBoxItem' && currentNode.data.name !== 'ListImageBoxItem'
    )
  }

  if (fun) {
    return fun(outgoingNode, currentNode, helpers)
  } else {
    return true
  }
}

export const canDropBlock = (currentNode, targetNode) => {
  const Block = resolver[targetNode.data.name]

  if (Block) {
    return Block.craft.rules.canMoveIn(currentNode, targetNode)
  }

  return false
}

export const canMoveInOnlyCols = (incomingNode, currentNode, helper) => {
  return incomingNode.data.name === 'Col'
}

export const canMoveInOnlyIcons = (incomingNode, currentNode, helper) => {
  return incomingNode.data.name === 'ListIconBoxItem'
}
